/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  path {
    &.fill-1 {
      fill: ${theme.color.matchTit1};
    }
    &.fill-2 {
      fill: ${theme.color.themeTxt};
    }
    &.fill-3 {
      fill: ${theme.color.modalyellow};
    }
  }
`
export default class SendMessageIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" css={Color}>
        <g id="그룹_5876" data-name="그룹 5876" transform="translate(-5609 4847)">
          <rect id="사각형_4882" data-name="사각형 4882" width="34" height="34" transform="translate(5609 -4847)" fill="red" opacity="0"/>
          <path id="빼기_5" className="fill-1" data-name="빼기 5"
                d="M17.966,16.19H3.09a.128.128,0,0,1-.028,0,.181.181,0,0,0-.042-.006H2.9A2.9,2.9,0,0,1,0,13.28V3.1A2.922,2.922,0,0,1,.93.97.015.015,0,0,0,.941.965a.013.013,0,0,1,.01,0A.022.022,0,0,1,.97.94,2.885,2.885,0,0,1,2.98,0h14.5A2.849,2.849,0,0,1,19.3.78l.01-.011a2.951,2.951,0,0,1,.85,1,2.917,2.917,0,0,1,.32,1.329V4.4a2.3,2.3,0,0,0-2.254,2.287V9.907a2.3,2.3,0,0,0,2.254,2.287V13.28a2.9,2.9,0,0,1-2.51,2.86v.049Zm2.51-6h0a.287.287,0,0,1-.253-.285V6.691a.287.287,0,0,1,.254-.285v3.786Z"
                transform="translate(5612 -4838)" fill="#294c72" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"/>
          <path id="패스_4954" data-name="패스 4954" d="M697.4,415.074" transform="translate(4931.912 -5249.663)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.3"/>
          <path id="패스_4955" className="fill-2" data-name="패스 4955" d="M691.944,420.132a.65.65,0,0,1-.409-1.156l5.453-4.408a.65.65,0,0,1,.816,1.012l-5.452,4.4A.652.652,0,0,1,691.944,420.132Z" transform="translate(4931.912 -5249.663)" fill="#fff"/>
          <path id="패스_4956" className="fill-2" data-name="패스 4956" d="M688.764,420.113a.644.644,0,0,1-.409-.146l-5.641-4.564a.65.65,0,0,1,.819-1.01l5.64,4.564a.651.651,0,0,1-.409,1.156Z" transform="translate(4931.912 -5249.663)" fill="#fff"/>
          <path id="패스_4957" className="fill-2" data-name="패스 4957" d="M690.357,421.012a2.035,2.035,0,0,1-1.264-.439l-.741-.609a.649.649,0,0,1,.824-1l.731.6a.749.749,0,0,0,.916-.009l.712-.575a.65.65,0,1,1,.817,1.012l-.72.58A2.052,2.052,0,0,1,690.357,421.012Z" transform="translate(4931.912 -5249.663)" fill="#fff"/>
          <path id="패스_4958" className="fill-2" data-name="패스 4958" d="M683.275,425.394a.65.65,0,0,1-.45-1.119l5.489-5.281a.65.65,0,0,1,.933.906l-.033.031-5.489,5.281A.646.646,0,0,1,683.275,425.394Z" transform="translate(4931.912 -5249.663)" fill="#fff"/>
          <path id="패스_4959" className="fill-2" data-name="패스 4959" d="M697.4,425.394a.645.645,0,0,1-.451-.183l-5.452-5.261a.65.65,0,0,1,.855-.979.454.454,0,0,1,.045.043l5.452,5.262a.65.65,0,0,1-.451,1.118Z" transform="translate(4931.912 -5249.663)" fill="#fff"/>
          <path id="빼기_6" className="fill-3" data-name="빼기 6" d="M5.583,9.958h0a.388.388,0,0,1-.39-.382v-1.7H2.287A.287.287,0,0,1,2,7.588V4.371a.287.287,0,0,1,.287-.287h2.9v-1.7A.389.389,0,0,1,5.568,2a.428.428,0,0,1,.277.11L9.61,5.7l.689-.724-.674.736a.388.388,0,0,1-.014.548L5.851,9.851A.388.388,0,0,1,5.583,9.958Z" transform="translate(5630.223 -4835.681)" fill="#ea8902" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"/>
        </g>
      </svg>

    )
  }
}
